import * as Inspector from 'avo-inspector';

import { AvoEnv, avoInspectorApiKey, initAvo } from './Avo';
import { Gatekeeper } from '../gatekeeper';

const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';

const inspector = new Inspector.AvoInspector({
  apiKey: avoInspectorApiKey,
  env: isDevelopment ? Inspector.AvoInspectorEnv.Dev : Inspector.AvoInspectorEnv.Prod,
  version: __SHORT_VERSION_HASH__,
  appName: 'Fulfillment Tools',
});

inspector.enableLogging(false);

const silentLogger = {
  logDebug: () => {
    return true;
  },
  logWarn: () => {
    return true;
  },
  logError: () => {
    return true;
  },
};

export const avoInit = () => {
  initAvo(
    {
      env: isDevelopment ? AvoEnv.Dev : AvoEnv.Prod,
      inspector,
      webDebugger: false,
      avoLogger: silentLogger,
    },
    {},
    Gatekeeper,
  );
};
